const componentId = 'cnos_intelli-assistant';
let trace = null;
const { version } = require('../../package.json');
// 设置arms trace
export async function setArmsTrace(tracker) {
    trace = tracker;
}
/**
 * 自定义上报
 * @param action
 * @param params
 * @param custom
 */
export async function logCustom(action, params = {}, c3) {
    // console.log('logCustom', action, params, c3, custom);
    log('logCustom', {
        p1: componentId,
        c1: action,
        c2: typeof params !== 'string' ? JSON.stringify(params) : params,
        c3: typeof c3 !== 'string' ? JSON.stringify(c3) : c3,
        c4: version,
    });
}
export function getTrace() {
    // @ts-ignore
    return trace || window.frameworkTrace || window.trace || window.coneArmsTrace;
}
/**
 * 异常上报
 * @param err
 */
export async function logError(err, otherInfo) {
    log('logError', err, {
        c1: componentId,
        c4: version,
        ...otherInfo,
    });
}
// 通用上报
async function log(logMethod, logItem, otherInfo) {
    try {
        // console.log('logMethod', logMethod, logItem)
        const trace = getTrace();
        trace?.[logMethod](logItem, otherInfo);
    }
    catch (e) {
        console.error(e);
        // 监控本身的报错，吃掉
    }
}
